import { Permission } from '@services/role';
import { Type } from 'class-transformer';

export class Organization {
	id: string;
	parentId?: string;

	@Type(() => Organization)
	parentOrganization?: Organization;

	name: string;
	subOrgName?: string;
	domain: string;
	address: string;
	vat: string;
	//TODO: remove latitude and longitute
	// latitude?: string;
	// longitude?: string;
	permissions: Permission[];
	isInfraSeller?: boolean;
	isVehicleSeller?: boolean;
	isB2CSeller?: boolean;
	fastLogin?: boolean;
}
